import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { retry } from 'rxjs/operators';

@Component({
  selector: 'app-reports-dashboard',
  standalone: false,
  templateUrl: './reports-dashboard.component.html',
  styleUrls: ['./reports-dashboard.component.css']
})
export class ReportsDashboardComponent implements OnInit {

  reports: any[] = [];
  categories: string[] = [];
  loading = true;
  actionLoading: { [key: string]: string } = {};

  private baseUrl = `${environment.apiUrl}/report-dashboard`;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.loadReports();
  }

  loadReports(): void {
    this.loading = true;
    this.http.get<any>(this.baseUrl).pipe(retry(2)).subscribe({
      next: (res) => {
        this.reports = res.reports || [];
        this.categories = [...new Set(this.reports.map((r: any) => r.category))] as string[];
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load reports', err);
        this.loading = false;
      }
    });
  }

  getReportsByCategory(category: string): any[] {
    return this.reports.filter(r => r.category === category);
  }

  isActionLoading(key: string, action: string): boolean {
    return this.actionLoading[key] === action;
  }

  isAnyActionLoading(key: string): boolean {
    return !!this.actionLoading[key];
  }

  viewReport(report: any): void {
    this.actionLoading[report.key] = 'view';
    this.http.post<any>(`${this.baseUrl}/${report.key}/view`, {}).subscribe({
      next: (res) => {
        delete this.actionLoading[report.key];
        if (res.success && res.html) {
          const win = window.open('', '_blank');
          if (win) {
            win.document.write(res.html);
            win.document.close();
          } else {
            alert('Popup was blocked. Please allow popups for this site.');
          }
        } else {
          alert(res.error || 'No data available for this report');
        }
      },
      error: (err) => {
        delete this.actionLoading[report.key];
        const msg = (err.error && err.error.error) ? err.error.error : (err.statusText || 'Server error');
        alert('Error generating report: ' + msg + ' (HTTP ' + err.status + ')');
      }
    });
  }

  runReport(report: any): void {
    if (!confirm(`Send "${report.name}" to all recipients?`)) return;
    this.actionLoading[report.key] = 'run';
    this.http.post<any>(`${this.baseUrl}/${report.key}/run`, {}).subscribe({
      next: (res) => {
        delete this.actionLoading[report.key];
        if (res.success) {
          alert(res.message);
          this.loadReports();
        } else {
          alert(res.error || 'Failed to run report');
        }
      },
      error: (err) => {
        delete this.actionLoading[report.key];
        const msg = (err.error && err.error.error) ? err.error.error : (err.statusText || 'Server error');
        alert('Error running report: ' + msg + ' (HTTP ' + err.status + ')');
      }
    });
  }

  testReport(report: any): void {
    this.actionLoading[report.key] = 'test';
    this.http.post<any>(`${this.baseUrl}/${report.key}/test`, {}).subscribe({
      next: (res) => {
        delete this.actionLoading[report.key];
        if (res.success) {
          alert(res.message);
        } else {
          alert(res.error || 'Failed to run test');
        }
      },
      error: (err) => {
        delete this.actionLoading[report.key];
        const msg = (err.error && err.error.error) ? err.error.error : (err.statusText || 'Server error');
        alert('Error running test: ' + msg + ' (HTTP ' + err.status + ')');
      }
    });
  }
}
